/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { API_IMG_ANNOUNCE_FILE, Adapter, AnnounceService, AnnounceStatusEnum, AnnouncementDto, AnnouncementTypeEnum, Helper, IFormAnnouncement, IFormQuestion, UpdateAnswerRequestDto } from 'app/modules/core'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { catchErrorMsg } from 'app/modules/core/helpers/Helper'

import 'app/components/text-editor/text-editor.css'

const AnnounceDetailPage: FC = () => {
    const [loading, setLoading] = useState(true)
    const [pageLoad, setPageLoad] = useState(true)
    const { id } = useParams()
    const navigate = useNavigate()

    const init: IFormAnnouncement = {
        id: 0,
        seasonId: 0,
        title: '',
        description: null,
        status: '',
        point: 0,
        expiredDate: new Date(),
        announcementFiles: [],
        announceQuestions: [],
        isActive: false,
        createdDate: new Date(),
        type: AnnouncementTypeEnum[AnnouncementTypeEnum.Acknowledge],
        isRead: false,
        isShowModel: false,

    }
    const [data, setData] = useState<IFormAnnouncement>(init)


    useEffect(() => {
        const init = () => {
            AnnounceService.GetByIdAndRead(Number(id)).then((result) => {
                const res = result.data.result
                if (res) {
                    const modal = Adapter.FormAnnouncement(res)
                    setData(modal)
                    setPageLoad(false)
                }

            }).catch((res) => {
                toast.error(catchErrorMsg(res))
                setPageLoad(false)
                navigate('/announce')
            })
        }
        setLoading(false)
        init()
    }, [])

    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-4'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }
    const formSchema = Yup.object().shape({
        //answer: Yup.string().required('require'),   
        announceQuestions: Yup.array().of(
            Yup.object().shape({
                answer: Yup.string().required('require'),
            })
        )
    })

    const DisplayTextSave = (type: string) => {
        return <>{type === AnnouncementTypeEnum[AnnouncementTypeEnum.Acknowledge] ? 'รับทราบประกาศ' : 'ส่งคำตอบ'}</>
    }

    const onSubmit = (value: IFormAnnouncement) => {
        setLoading(true)
        try {

            const userAnswer = value.announceQuestions.map((item) => ({
                announceToAnswerId: value.id,
                announceQuestionId: item.id,
                answer: item.answer
            }))


            const answer: UpdateAnswerRequestDto = {
                IsAcknowledge: value.type === AnnouncementTypeEnum[AnnouncementTypeEnum.Acknowledge],
                AnnounceUserAnswers: userAnswer
            }
            AnnounceService.UpdateAnswers(value.id, answer)
                .then((res) => {
                    toast.success('Save Success.')
                    navigate('/announce')
                    setLoading(false)
                }).catch((res) => {
                    toast.error(catchErrorMsg(res))
                    setLoading(false)
                })
        } catch (ex) {
            toast.error(catchErrorMsg(ex))
            setLoading(false)
        }


    }


    const checkStatus = (status: string) => {
        return [
            AnnounceStatusEnum[AnnounceStatusEnum.Complete],
            AnnounceStatusEnum[AnnounceStatusEnum.InComplete],
            AnnounceStatusEnum[AnnounceStatusEnum.Fail],
            AnnounceStatusEnum[AnnounceStatusEnum.Expired]
        ]
            .includes(status)
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className='card mb-5 mb-xl-8 '>
                <div className='card-header d-flex flex-column ' >
                    <div><h1>วันที่ประกาศ {moment(data.createdDate).format("DD MMM YYYY")}</h1></div>
                    <div><h2>หัวข้อ: {data.title}</h2> </div>
                </div>


                {pageLoad && <span className='card-body py-3 indicator-progress' style={{minHeight: '200px', display: 'block' }}>
                    Loading...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>}
                {/* begin::Body */}
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}
                >
                    {props => (<Form>
                        <div className='card-body py-3' style={{ minHeight: '200px' }}>

                            <p className='p-20 fs-4'
                                dangerouslySetInnerHTML={{ __html: data.description ? Helper.toHtml(data.description) : '' }}
                            ></p>
                            {
                                data.announcementFiles && data.announcementFiles.map((item, index) => {
                                    return <div key={index} >
                                        <img className='img-thumbnail rounded mx-auto d-block ' style={{ maxWidth: '348px' }} src={`${API_IMG_ANNOUNCE_FILE}/` + item.fileName} alt='img' />
                                    </div>
                                })
                            }

                        </div>
                        <div className='card-body py-3'>


                            {props.values.type === AnnouncementTypeEnum[AnnouncementTypeEnum.Question] && <>
                                {<FieldArray name='announceQuestions' render={(() => {
                                    return <>
                                        {props.values.announceQuestions && props.values.announceQuestions.length > 0 && (
                                            props.values.announceQuestions.map((item, index) => {
                                                const frmError =
                                                    ((props.errors.announceQuestions?.length &&
                                                        props.errors.announceQuestions[
                                                        index
                                                        ]) as unknown as FormikErrors<IFormQuestion>) || {}
                                                const frmTouched =
                                                    (props.touched.announceQuestions?.length && props.touched.announceQuestions[index]) || {}
                                                return (
                                                    <>
                                                        {index > 0 && <hr />}
                                                        <CellStyle lable={'คำถาม ' + (index + 1)}>
                                                            <span className=''
                                                                dangerouslySetInnerHTML={{ __html: item.question }}
                                                            ></span>
                                                        </CellStyle>

                                                        <CellStyle lable={'คำตอบ'}>
                                                            <Field
                                                                as='textarea'
                                                                autoComplete='off'
                                                                name={`announceQuestions.${index}.answer`}
                                                                className={
                                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                                    (frmError.answer && frmTouched.answer ? ' is-invalid' : '')
                                                                }
                                                                rows={3}
                                                                disabled={checkStatus(props.values.status)}
                                                            />
                                                            <ErrorMessage name={`announceQuestions.${index}.answer`} component='div' className='text-danger' />
                                                        </CellStyle>


                                                    </>

                                                )
                                            })
                                        )}

                                    </>
                                })} />}


                            </>
                            }
                            <div className='card-footer d-flex py-6 px-9'>

                                {checkStatus(props.values.status) ? <>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={true}>ส่งคำตอบไปแล้ว</button>
                                </> : <>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && DisplayTextSave(props.values.type)}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>
                                </>}



                                <button className='btn btn-light' onClick={() => navigate('/announce')}> Back</button>
                            </div>
                        </div>


                    </Form>)}

                </Formik>

                {/* begin::Body */}

            </div>       
        </>
    )
}
export { AnnounceDetailPage }
